<template>
  <v-main class="grey lighten-4">
    <v-container>
      <v-card class="rounded-xl elevation-4" max-width="1200">
        <!-- Cabeçalho -->
        <v-card-title class="primary white--text">
          <v-icon left color="white">mdi-pencil</v-icon>
          Editar Serviço
        </v-card-title>

        <v-divider></v-divider>

        <!-- Formulário -->
        <v-form v-model="valid" ref="form" class="pa-6">
          <!-- Nome do Serviço -->
          <v-text-field
            v-model="nomeEspecialidade"
            label="Nome do Serviço"
            disabled
            outlined
            dense
            prepend-icon="mdi-rename-box"
          ></v-text-field>

          <!-- Local da Recepcionista -->
          <v-autocomplete
            v-model="idLocalEscolhido"
            :items="listaLocais"
            item-value="idLocal"
            item-text="nomeLocal"
            label="Local da Recepcionista *"
            :rules="[(v) => !!v || 'Local obrigatório']"
            outlined
            dense
            prepend-icon="mdi-map-marker"
          ></v-autocomplete>

          <!-- Seção Condicional: Configurações Médicas -->
          <template v-if="atendimentoMedico == 1">
            <v-subheader class="pl-0 mt-2 text-subtitle-1 primary--text">
              <v-icon left color="primary">mdi-stethoscope</v-icon>
              Configurações Médicas
            </v-subheader>

            <!-- Locais de Atendimento -->
            <v-autocomplete
              v-model="idLocaisMedico"
              :items="listaLocais"
              item-value="idLocal"
              item-text="nomeLocal"
              label="Locais de Atendimento *"
              :rules="[(v) => v && v.length > 0 || 'Selecione pelo menos um local']"
              outlined
              dense
              multiple
              chips
              small-chips
              prepend-icon="mdi-hospital-marker"
              @input="alterarLocalAtendimento()"
            ></v-autocomplete>

            <!-- Médicos -->
            <v-autocomplete
              v-model="listaMedicosServico"
              :items="listaMedicos"
              item-value="idMedico"
              :item-text="item => `${item.nome} - ${item.login}`"
              label="Médicos *"
              :rules="[listaMedicosServico.length > 0 || listaTecnicosServico.length > 0 || 'Selecione pelo menos um prestador']"
              outlined
              dense
              multiple
              chips
              small-chips
              prepend-icon="mdi-doctor"
              @input="alterarListaMedicos()"
            ></v-autocomplete>

            <!-- Técnicos -->
            <v-autocomplete
              v-model="listaTecnicosServico"
              :items="listaTecnicos"
              item-value="idMedico"
              :item-text="item => `${item.nome} - ${item.login}`"
              label="Técnicos *"
              :rules="[listaMedicosServico.length > 0 || listaTecnicosServico.length > 0 || 'Selecione pelo menos um prestador']"
              outlined
              dense
              multiple
              chips
              small-chips
              prepend-icon="mdi-account-cog"
              @input="alterarListaTecnicos()"
            ></v-autocomplete>
          </template>

          <!-- Dias da Semana -->
          <v-autocomplete
            v-model="diasDaSemana"
            :items="listaDiasDaSemana"
            item-value="diaSemana"
            item-text="dia"
            label="Dias da Semana *"
            :rules="[(v) => v && v.length > 0 || 'Selecione pelo menos um dia']"
            outlined
            dense
            multiple
            chips
            small-chips
            prepend-icon="mdi-calendar"
            @input="alterarDiasDaSemana()"
          ></v-autocomplete>

          <!-- Opções -->
          <v-row class="mt-2">
            <v-col cols="12" sm="6">
              <v-checkbox
                v-model="exbibirAtendente"
                label="Exibir serviço para a Atendente?"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12" sm="6">
              <v-checkbox
                v-model="peso"
                :false-value="0"
                :true-value="1"
                label="Prioridade para a recepcionista?"
                color="primary"
                hide-details
              ></v-checkbox>
            </v-col>
            <v-col cols="12">
              <v-checkbox
                v-model="checkbox"
                :rules="[(v) => !!v || 'Você deve concordar para continuar']"
                label="Você concorda com as alterações?"
                color="primary"
                required
              ></v-checkbox>
            </v-col>
          </v-row>

          <!-- Mensagens de Feedback -->
          <v-alert
            v-model="erroEditar"
            type="error"
            dismissible
            class="mt-4"
          >
            Erro ao editar serviço!
          </v-alert>

          <v-alert
            v-model="erroDiasIguais"
            type="error"
            dismissible
            class="mt-4"
          >
            Dias da semana já cadastrados para este Serviço
          </v-alert>

          <v-alert
            v-model="erroLociasIguais"
            type="error"
            dismissible
            class="mt-4"
          >
            Locais de atendimentos já cadastrados para esse serviço
          </v-alert>

          <v-alert
            v-model="sucessoEditar"
            type="success"
            dismissible
            class="mt-4"
          >
            Serviço atualizado com sucesso!
          </v-alert>

          <!-- Ações -->
          <v-card-actions class="px-0 mt-4">
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              large
              rounded
              @click="alterarServico"
              :class="{ red: !valid, green: valid }"
              :disabled="!valid"
            >
              <v-icon left>mdi-content-save</v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="grey darken-1"
              large
              rounded
              outlined
              to="/servicosUnidade"
            >
              <v-icon left>mdi-arrow-left</v-icon>
              Voltar
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
// O script permanece EXATAMENTE o mesmo que o original
import Cookies from 'js-cookie'
import administradorUnidadeService from '../../../services/administradorUnidade.service'

export default {
  name: 'editarUnidade',
  components: {
    // HelloWorld
  },
  data () {
    return {
      item: '',
      erroEditar: false,
      diasDaSemana: [],
      servico: {
        idExameEspecialidade: '',
        nomeEspecialidade: '',
        atendimentoMedico: ''
      },
      listaMedicos: [],
      listaMedicosServico: [],
      listaMedicosServicoInicial: [],
      idMedicos: [],
      listaTecnicos: [],
      listaTecnicosServico: [],
      listaTecnicosServicoInicial: [],
      atendimentoMedico: '',
      erroDiasIguais: false,
      erroLociasIguais: false,
      alterouDiasDaSemana: false,
      alterouLocaisAtendimento: false,
      alterouListaMedicos: false,
      alterouListaTecnicos: false,
      diasDaSemanaInicial: [],
      sucessoEditar: false,
      listaLocais: [],
      diaSemana: '',
      idServico: '',
      isEditing: true,
      nomeEspecialidade: '',
      listaDiasDaSemana: [{
        dia: 'Segunda-feira',
        diaSemana: 1
      }, {
        dia: 'Terça-feira',
        diaSemana: 2
      },
      {
        dia: 'Quarta-feira',
        diaSemana: 3
      }, {
        dia: 'Quinta-feira',
        diaSemana: 4
      },
      {
        dia: 'Sexta-feira',
        diaSemana: 5
      }, {
        dia: 'Sábado',
        diaSemana: 6
      }, {
        dia: 'Domingo',
        diaSemana: 0
      }
      ],
      idLocalEscolhido: '',
      idLocaisMedico: '',
      idLocaisMedicoInicial: '',
      valid: false,
      checkbox: false,
      exbibirAtendente: '',
      peso: 0,
      nomeRules: [
        (v) => v && v.length > 2 || 'nome deve ter mais de 5 caracteres'
      ]
    }
  },
  mounted () {
    console.log('em mounted')
    if (!this.$route.params.item) {
      this.$router.push({
        name: 'servicosUnidade'
      })
      return
    }

    console.log('parametro', this.$route.params.item)
    this.atendimentoMedico = this.$route.params.item.atendimentoMedico
    this.diasDaSemana = this.$route.params.diasDaSemana
    this.diasDaSemanaInicial = this.$route.params.diasDaSemana
    this.idServico = this.$route.params.item.idServico
    this.peso = this.$route.params.item.peso
    this.exbibirAtendente = this.$route.params.item.exibirAtendente
    this.diaSemana = this.item = this.$route.params.item.diaSemana
    this.nomeEspecialidade = this.$route.params.item.nomeEspecialidade
    this.idLocalEscolhido = this.$route.params.item.idLocal
    this.erroEditar = false
    this.sucessoEditar = false
    this.retornarLocais()
    this.retornarLocalMedico(this.idServico)
    if (this.atendimentoMedico == 1) {
      this.retornarTodosMedicos()
      this.retornarPossiveisTecnicos()
      // this.retornarMedicoTecnico() removed here
    }
  },
  methods: {

    retornarPossiveisTecnicos () {
      administradorUnidadeService.administradorUnidade
        .retornarPossiveisTecnicos()
        .then(rsp => {
          console.log('rsp oi: possiv tecn', rsp.data)
          this.listaTecnicos = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarTodosMedicos () {
      administradorUnidadeService.administradorUnidade
        .retornarTodosMedicos()
        .then(rsp => {
          console.log('rsp oi: tds medcs', rsp.data)
          this.listaMedicos = rsp.data
          this.retornarMedicoTecnico()
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarMedicoTecnico () {
      administradorUnidadeService.administradorUnidade
        .retornarMedicoTecnico(this.idServico)
        .then(rsp => {
          const medicos = rsp.data.filter(element => element.tecnico === 0)
          const tecnicos = rsp.data.filter(element => element.tecnico === 1)

          // Atualizar listas de médicos e técnicos
          this.listaMedicosServico = [...medicos]
          this.listaMedicosServicoInicial = [...medicos]
          this.listaTecnicosServico = [...tecnicos]
          this.listaTecnicosServicoInicial = [...tecnicos]

          console.log('Médicos:', this.listaMedicosServico)
          console.log('Técnicos:', this.listaTecnicosServico)

          this.mostrarDiferencas()
        })
        .catch(err => {
          // Tratar erro
          console.error('Erro ao retornar médicos e técnicos:', err)
        })
    },

    mostrarDiferencas () {
      // Converter listas em Sets para busca rápida
      const medicosSet = new Set(this.listaMedicos.map(medico => medico.idMedico))
      const tecnicosSet = new Set(this.listaTecnicos.map(tecnico => tecnico.idMedico))

      // Filtrar médicos e técnicos que não estão na lista geral
      const difMed = this.listaMedicosServico.filter(element1 => !medicosSet.has(element1.idMedico))
      const difTec = this.listaTecnicosServico.filter(element1 => !tecnicosSet.has(element1.idMedico))

      console.log('Médicos não encontrados na lista geral:', difMed)
      console.log('Técnicos não encontrados na lista geral:', difTec)
    },

    alterarDiasDaSemana () {
      this.alterouDiasDaSemana = true
    },

    alterarLocalAtendimento () {
      this.alterouLocaisAtendimento = true
    },

    alterarListaMedicos () {
      this.alterouListaMedicos = true
    },
    alterarListaTecnicos () {
      this.alterouListaTecnicos = true
    },

    alterarServico () {
      if (this.$refs.form.validate()) {
        let diasDaSemanaAux = []
        let idLocaisMedicoAux = []
        let idMedicos = []
        let idTecnicos = []
        let diasDaSemanaSemNull = []
        this.erroEditar = false
        this.sucessoEditar = false
        this.erroDiasIguais = false // n terá mais
        this.erroLociasIguais = false // n tera mais..

        if (this.alterouLocaisAtendimento) {
          idLocaisMedicoAux = this.verificarIdLocaisMedico()
          // console.log('idLocaisMedicoAux', idLocaisMedicoAux);
        }

        if (this.alterouListaMedicos) {
          idMedicos = this.verificarListaMedicos()
        }

        if (this.alterouListaTecnicos) {
          idTecnicos = this.verificarListaTecnicos()
        }
        console.log('imprimindo retorno ids tecnicos..', idTecnicos)
        console.log('imprimindo retorno ids medicos..', idMedicos)

        if (this.diasDaSemana.length == 0 && this.diasDaSemanaInicial.length > 0) {
          for (let index = 0; index < this.diasDaSemanaInicial.length; index++) {
            const element = this.diasDaSemanaInicial[index]
            diasDaSemanaAux[index] = {
              diaSemana: element,
              status: 0
            }
          }
        }
        // talvez nunca caia aqui..
        else if (this.diasDaSemanaInicial.length == 0 && this.diasDaSemana.length > 0) {
          console.log('segundo if')
          for (let index = 0; index < this.diasDaSemana.length; index++) {
            const element = this.diasDaSemana[index]
            diasDaSemanaAux[index] = {
              diaSemana: element,
              status: 1
            }
          }
          // console.log(servicosAux);
          // return
        } else {
          let diasDaSemanaInicial = this.diasDaSemanaInicial
          for (let index = 0; index < this.diasDaSemana.length; index++) {
            const element = this.diasDaSemana[index]
            diasDaSemanaAux[index] = {
              diaSemana: element,
              status: null
            }
          }

          diasDaSemanaAux.forEach(function (elementEscolhido, indexAux) {
            let estava = false
            let index = 0
            for (let index = 0; index < diasDaSemanaInicial.length; index++) {
              const element = diasDaSemanaInicial[index]
              if (element == elementEscolhido.diaSemana) {
                estava = true
              }
            }
            if (!estava) {
              diasDaSemanaAux[indexAux].status = 1
            }
          })

          diasDaSemanaInicial.forEach(function (elementInicial, indexInicial) {
            let removeu = false
            let diaSemana = 0
            for (let index = 0; index < diasDaSemanaAux.length; index++) {
              const element = diasDaSemanaAux[index]
              if (element.diaSemana == elementInicial) {
                removeu = true
                // diaSemana = element.diaSemana
              }
            }
            if (!removeu) {
              diaSemana = elementInicial
              diasDaSemanaAux.push({
                diaSemana: diaSemana,
                status: 0
              })
            }
          })
          console.log(diasDaSemanaAux)

          for (let i = 0; i < diasDaSemanaAux.length; i++) {
            if (diasDaSemanaAux[i].status != null) {
              diasDaSemanaSemNull.push(diasDaSemanaAux[i])
              // console.log(diasDaSemanaAux);
            }
          }
          diasDaSemanaAux = diasDaSemanaSemNull
          console.log('dias da semana sem null') // n precisa mais verificar se é null
          console.log(diasDaSemanaAux)
        }
        administradorUnidadeService.administradorUnidade
          .alterarServico(this.idServico, this.idLocalEscolhido, diasDaSemanaAux, idLocaisMedicoAux,
            this.exbibirAtendente, this.peso, idMedicos, idTecnicos)
          .then(rsp => {
            console.log('rsp oi:')
            if (rsp.data == 'erro') {
              this.erroEditar = true
            }

            if (rsp.data == true) {
              setTimeout(() => this.$router.push({
                path: '/servicosUnidade'
              }), 2000)
              this.sucessoEditar = true
              this.clear()
            }
          })
          .catch(err => {
            // handle your error here
            console.log(err)
          })
      }
    },

    // novo tecnico

    verificarListaTecnicos () {
      const listaTecnicosAux = new Map()
      const listaTecnicosSemNull = []

      // Preencher listaTecnicosAux com base em listaTecnicosServicoInicial
      this.listaTecnicosServicoInicial.forEach(element => {
        listaTecnicosAux.set(element.idMedico, { idMedico: element.idMedico, status: 0 })
      })

      // Atualizar listaTecnicosAux com base em listaTecnicosServico
      this.listaTecnicosServico.forEach(element => {
        if (listaTecnicosAux.has(element)) {
          // Técnico já existe na lista inicial, portanto atualiza o status para 1
          listaTecnicosAux.get(element).status = 1
        } else {
          // Técnico é novo, adiciona à lista
          listaTecnicosAux.set(element, { idMedico: element, status: 1 })
        }
      })

      // Verificar técnicos removidos e adicioná-los à listaTecnicosAux
      this.listaTecnicosServicoInicial.forEach(elementInicial => {
        if (!listaTecnicosAux.has(elementInicial.idMedico)) {
          listaTecnicosAux.set(elementInicial.idMedico, { idMedico: elementInicial.idMedico, status: 0 })
        }
      })

      // Filtrar técnicos com status definido
      listaTecnicosAux.forEach(value => {
        if (value.status !== null) {
          listaTecnicosSemNull.push(value)
        }
      })

      console.log('Técnicos atualizados (sem null)')
      return listaTecnicosSemNull
    },

    // novo medico

    verificarListaMedicos () {
      const listaMedicosAux = new Map()
      const listaMedicosSemNull = []

      // Preencher listaMedicosAux com base em listaMedicosServicoInicial
      this.listaMedicosServicoInicial.forEach(element => {
        listaMedicosAux.set(element.idMedico, { idMedico: element.idMedico, status: 0 })
      })

      // Atualizar listaMedicosAux com base em listaMedicosServico
      this.listaMedicosServico.forEach(element => {
        if (listaMedicosAux.has(element)) {
          // Médico já existe na lista inicial, portanto atualiza o status para 1
          listaMedicosAux.get(element).status = 1
        } else {
          // Médico é novo, adiciona à lista
          listaMedicosAux.set(element, { idMedico: element, status: 1 })
        }
      })

      // Verificar médicos removidos e adicioná-los à listaMedicosAux
      this.listaMedicosServicoInicial.forEach(elementInicial => {
        if (!listaMedicosAux.has(elementInicial.idMedico)) {
          listaMedicosAux.set(elementInicial.idMedico, { idMedico: elementInicial.idMedico, status: 0 })
        }
      })

      // Filtrar médicos com status definido
      listaMedicosAux.forEach(value => {
        if (value.status !== null) {
          listaMedicosSemNull.push(value)
        }
      })

      console.log('Dias da semana sem null')
      return listaMedicosSemNull
    },

    verificarIdLocaisMedico () {
      let idLocaisMedicoAux = []
      let idLocaisMedicoAuxNull = []
      // console.log('primeiro if', this.idLocaisMedico)
      if (this.idLocaisMedico.length == 0 && this.idLocaisMedicoInicial.length > 0) { // verificar se pode cair aqui
        console.log('primeiro if')
        for (let index = 0; index < this.idLocaisMedicoInicial.length; index++) {
          const element = this.idLocaisMedicoInicial[index]
          idLocaisMedicoAux[index] = {
            idLocal: element,
            status: 0
          } // 0 removeu
        }
      } else if (this.idLocaisMedicoInicial.length == 0 && this.idLocaisMedico.length > 0) { // verificar se ppode cair aqui
        console.log('segundo if 2 -', this.idLocaisMedicoInicial, this.idLocaisMedico)
        for (let index = 0; index < this.idLocaisMedico.length; index++) {
          const element = this.idLocaisMedico[index]
          idLocaisMedicoAux[index] = {
            idLocal: element,
            status: 1
          } // 1 adicionou
        }
      } else {
        console.log('else..')
        let idLocaisMedicoInicial = this.idLocaisMedicoInicial
        for (let index = 0; index < this.idLocaisMedico.length; index++) {
          const element = this.idLocaisMedico[index]
          idLocaisMedicoAux[index] = {
            idLocal: element,
            status: null
          }
        }

        idLocaisMedicoAux.forEach(function (elementEscolhido, indexAux) {
          let estava = false
          let index = 0
          for (let index = 0; index < idLocaisMedicoInicial.length; index++) {
            const element = idLocaisMedicoInicial[index]
            if (element.idLocal == elementEscolhido.idLocal) {
              estava = true
            }
          }
          if (!estava) {
            idLocaisMedicoAux[indexAux].status = 1
          }
        })

        idLocaisMedicoInicial.forEach(function (elementInicial, indexInicial) {
          let removeu = false
          let idLocal = 0
          for (let index = 0; index < idLocaisMedicoAux.length; index++) {
            const element = idLocaisMedicoAux[index]
            if (element.idLocal == elementInicial.idLocal) {
              removeu = true
              // idLocal = element.idLocal
            }
          }
          if (!removeu) {
            idLocal = elementInicial.idLocal
            idLocaisMedicoAux.push({
              idLocal: idLocal,
              status: 0
            })
          }
        })

        // console.log('------ ----- ', idLocaisMedicoAux)

        for (let i = 0; i < idLocaisMedicoAux.length; i++) {
          if (idLocaisMedicoAux[i].status != null) {
            idLocaisMedicoAuxNull.push(idLocaisMedicoAux[i])
            // console.log(idLocaisMedicoAux);
          }
        }
        idLocaisMedicoAux = idLocaisMedicoAuxNull
        // return idLocaisMedicoAux;
        console.log('idLocaisMedico sem null')
        console.log(idLocaisMedicoAux)
        return idLocaisMedicoAux
      }
      return idLocaisMedicoAux
    },

    retornarLocais () {
      administradorUnidadeService.administradorUnidade
        .retornarLocais()
        .then(rsp => {
          console.log('rsp oi locais:', rsp.data)
          this.listaLocais = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },

    retornarLocalMedico (idServico) {
      administradorUnidadeService.administradorUnidade
        .retornarLocalMedico(idServico)
        .then(rsp => {
          console.log('rsp oi localMedico:', rsp.data)
          this.idLocaisMedico = rsp.data
          this.idLocaisMedicoInicial = rsp.data
        })
        .catch(err => {
          // handle your error here
          console.log(err)
        })
    },
    clear () {
      this.$refs.form.reset()
    }

  },

  created () {
    // this.$eventHub.$on('logged-in', this.setaDescricao)
  }
}
</script>

<style scoped>
.v-card {
  border-radius: 12px;
  overflow: hidden;
}

.v-btn {
  text-transform: none;
  letter-spacing: normal;
  min-width: 120px;
}

.v-subheader {
  font-size: 1rem;
  height: 48px;
}

@media (max-width: 600px) {
  .v-card__title {
    font-size: 1.25rem;
    padding: 16px;
  }

  .v-btn {
    width: 100%;
    margin-bottom: 8px;
  }

  .v-card__actions {
    flex-direction: column;
  }
}
</style>
